// @ts-nocheck
import * as React from "react";

const AlertError: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M15.316 4H8.684L4 8.684v6.632L8.684 20h6.632L20 15.316V8.684L15.316 4Zm1.128 11.324-1.12 1.12L12 13.12l-3.324 3.324-1.12-1.12L10.88 12 7.556 8.676l1.12-1.12L12 10.88l3.324-3.324 1.12 1.12L13.12 12l3.324 3.324Z"
            />
        </svg>
    );
};

export default React.memo(AlertError);
